<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" style="position: relative; height: 100%; width: 100%; display:table;">
    <div style=" height: 100%; position: absolute; width: 100%;display:inline-table" class="mt-3 pr-0 mr-0">
      <table border="0" style="height:100%;width:100%">
        <tr>
          <td style="">
            <div class="row mb-3" v-if="procedure.Url != null && procedure.Url != ''">
              <a v-bind:href="procedure.Url" target="_blank">
                <span style="display:block;border:1px solid #ddd">
                  <img @load="onProcImgLoad" v-bind:alt="$t('no_image')" style="padding:10px;" v-bind:src="procedure.Url" width="100%" />
                </span>
              </a>
            </div>
            <div class="row">
              <div class="col-12 custom-form-label">
                {{$t('info')}}
                <button @click="expandInfo" type="button" class="btn btn-outline-light border-transparent  p-0 px-1" style="color: initial; margin-top: -3px">
                  <i style="cursor:pointer" class="icon-arrow-up32 icon" v-show="infoexpanded == true"></i>
                  <i style="cursor:pointer" class="icon-arrow-down32 icon" v-show="infoexpanded == false"></i>
                </button>
              </div>
            </div>
            <div class="row mt-2" v-show="infoexpanded == true">
              <div class="col-12">
                <button type='button' class='btn btn-outline-light' style="color:inherit" @click="clickItem(procedure.ProcUrlElement)">
                  <i class='icon-attachment'></i>
                </button>
                <button type='button' v-if="procedure.Url != null && procedure.Url != ''" class='btn btn-outline-light' style="color:inherit" @click="removeProcImg">
                  {{$t('remove_image')}} <i class='icon-trash ml-2'></i>
                </button>
              </div>
            </div>
            <div class="mb-3 mt-3" v-show="infoexpanded == true">
              <procedure-name ref="procedureNameComponent" mode="edit"></procedure-name>
            </div>
            <div class="row mt-3" v-show="infoexpanded == true">
              <div class="col-12 custom-form-label">
                {{$t('description')}}
                <!--<button @click="expandDescription" type="button" class="btn btn-outline-light border-transparent  p-0 px-1" style="color: initial; margin-top: -3px">
        <i style="cursor:pointer" class="icon-arrow-up32 icon" v-show="descriptionexpanded == true"></i>
        <i style="cursor:pointer" class="icon-arrow-down32 icon" v-show="descriptionexpanded == false"></i>
      </button>-->
              </div>
            </div>
            <div class="row mt-1" v-show="descriptionexpanded == true && infoexpanded == true">
              <div class="col-12">
                <textarea @change="onChange($event)" class="form-control" v-model="procedure.Description" v-bind:placeholder="$t('enter_description')" style="border:1px solid #ccc !important; padding:5px;"></textarea>
              </div>
            </div>
            <!--
            <div class="row mt-3" v-show="infoexpanded == true">
              <div class="col-12 custom-form-label">
                {{$t('success_message')}}
              </div>
            </div>
            <div class="row mt-1" v-show="infoexpanded == true">
              <div class="col-12">
                <textarea @change="onChange($event)" class="form-control" v-model="procedure.SuccessMessage" v-bind:placeholder="$t('success_message')" style="border:1px solid #ccc !important; padding:5px;"></textarea>
              </div>
            </div>
              -->
            <div class="row mt-3" v-if="procedure.EnableTimespent == true">
              <div class="container-fluid custom-form-label">
                <i class="icon-alarm mr-1"></i><span class="mt-3">{{$t('time_estimated')}}: <span class="font-weight-semibold">{{hours}}h, {{minutes}}min</span></span>
              </div>
              <form id="setTimeForm" name="setTimeForm" class="login-formx form-validate col-12" action="index.html" onsubmit="return false">
                <div class="col-lg-12">
                  <div class="row mt-1">
                    <div class="col-1 px-0">
                      <input required v-model="hours" @change="calCulatetime" type="text" id="txthour" v-bind:placeholder="$t('hours')" maxlength="5" name="hour" class="form-control" />
                    </div>
                    <div class="col-1 form-control" style="border:none;">
                      h
                    </div>
                    <div class="col-1 px-0">
                      <input required v-model="minutes" type="text" @change="calCulatetime" id="txtminute" v-bind:placeholder="$t('minutes')" maxlength="2" name="minute" class="form-control" />
                    </div>
                    <div class="col-9 form-control" style="border:none;">
                      m
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="row mt-3">
              <div class="col-12 custom-form-label">
                {{$store.translate('optional_elements')}}
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td valign="top" style="height:100%;padding:0px;">

            <div class="container-fluid p-0">
              <div class="row p-0 m-0" style="position:relative;">
                <div style="position:relative;" class="col-12 p-0">
                  <div id="nestedContainer" class="mt-1 pl-2 py-4" style="width: 100%; overflow-y: visible !important; overflow-x: auto !important; border: 1px dashed #ccc; position: relative; z-index: 1">
                    <nested-property ref="nestedproperty" class="base-item" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="itemSettings" v-bind:displaydropmessage="true" style="z-index:10000;" />
                  </div>
                </div>
                <div style="position:relative;" class="col-12 p-0 my-3">
                  <button type="button" style="width:100%;" class="btn btn-light text-center" @click="openSelector">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <element-selector ref="selector" @selected_element="addedElementFromSelector"></element-selector>
    <upload-container ref="uploadComponent" @change="urlChange2"></upload-container>
    <procedure-property-settings ref="propertySettings"></procedure-property-settings>
  </div>
</template>

<script>

  var urlerrors = [];
  var selectedElement = {};
  var internalurl = "";
  var timeEst = 0;
  import UploadService from "../services/UploadFilesService";
  import ModalEmpty from "../modals/modal-empty.vue";
  import TextInput from "../form-components/input-text.vue";
  //import UploadSelector2 from "../upload/upload-file-selector2.vue";
  import UploadContainer from "../upload/upload-container.vue";
  import draggable from "vuedraggable";
  import ProcedurePropertySettings from './procedure-property-settings.vue'
  import procedureName from './procedure-name.vue'


  var thisProcedure = {};

  export default {
    name: "procedure-editmode",
    display: "Nested (v-model & vuex)",
    order: 16,
    components: {
      procedureName,
      draggable,
      //UploadSelector2,
      ModalEmpty,
      TextInput,
      ProcedurePropertySettings,
      UploadContainer,
      UploadService,

    },
    props: {

    },
    data() {
      return {
        loadedProcedure: {},
        internalurl,
        selectedElement,
        urlerrors,
        timeEst,
        hours: 0,
        minutes: 0,
        elements: [],
        descriptionexpanded: true,
        infoexpanded: true,
        //fileName: '',
      };
    },
    computed: {
      procedure: {
        get() {

          $("#setTimeForm").validate({
            rules: {
              hour: {
                required: true,
                number: true
              },
              minute: {
                required: true,
                number: true,
                range: [0, 59]
              },
            }
          });


          return this.loadedProcedure;
        },
        set(value) {
          this.$store.commit('updateprocedure', value)
        }
      },
      Elements: {
        get() {
          return this.elements;
        },
        set(value) {
          this.elements = value;
        }
      }
    },
    methods: {
      openSelector() {
        this.$refs.selector.open();
      },
      addedElementFromSelector(element) {
        this.addingFromMenuClick(element)
      },
      removeProcImg() {
        this.internalurl = null;
        this.selectedElement.Url = null;
        this.procedure.Url = null;
        this.procedure.ProcUrlElement.Url = null;
        this.procedure.ProcUrlElement.Text = '';
        this.$store.markAsChanged();
      },
      onProcImgLoad() {
        //var url = this.procedure.Url;
        //if (url != null) {
        //  var id = "";
        //  var urlParts = url.split('?');
        //  if (urlParts.length > 1) {
        //    var urlSegments = urlParts[1].split('&');
        //    id = urlSegments[0].split('=')[1];
        //    UploadService.getFileInfo(id, this.showuserviews).then((response) => {              
        //      if (this.procedure.ProcUrlElement != null) {
        //        this.procedure.ProcUrlElement.Text = response.data.FileName;
        //      }
        //    });
        //  }
        //}

      },
      expandInfo() {
        this.infoexpanded = !this.infoexpanded;
        this.$forceUpdate();
      },
      expandDescription() {
        this.descriptionexpanded = !this.descriptionexpanded;
        this.$forceUpdate();
      },
      onChange() {
        this.$store.markAsChanged();
      },
      async setProcedure(val) {
        this.loadedProcedure = val;
        //this.$forceUpdate();
      },
      async loadElements(elements) {
        this.$refs.nestedproperty.setElements(elements);
        //this.$forceUpdate();
      },
      calCulatetime() {
        if (/^\d*$/.test(this.hours) === false) {
          this.hours = 0;
        }
        if (/^\d*$/.test(this.minutes) === false) {
          this.minutes = 0;
        }
        if (this.minutes > 59) {
          this.minutes = 0;
        }

        var h = parseInt(this.hours) + parseInt(this.minutes) / 60;
        this.procedure.EstimatedTimeTimeTicks = h * 36000000000;
        this.onChange(null);
      },
      urlValidationError(errors) {
        this.urlerrors = errors;
      },
      urlChange() {
        this.internalurl = null;
      },
      urlChange2(val, name, settings) {
        this.internalurl = val;
        this.selectedElement.Url = this.internalurl;
        //Vue.set(this.selectedElement, "Url", this.internalurl);
        //Vue.set(this, "internalurl", this.internalurl);
        //this.internalurl

        if (this.selectedElement == this.procedure.ProcUrlElement) {

          //var tmp = this.procedure;
          //tmp.Url = this.internalurl;
          Vue.set(this.procedure, "Url", this.internalurl);
          //procedure = tmp;
        }
        this.$forceUpdate();
        this.$store.markAsChanged();
      },
      saving() {
        if (this.internalurl != null) {
          this.selectedElement.Url = this.internalurl;
        }
        else {

        }

        this.internalurl = null;
        this.$refs.uploadComponent.clear();
        this.$refs.uploadComponent.close();
      },
      itemSettings(element) {
        this.$refs.propertySettings.setProperty(element);
        this.$refs.propertySettings.open();
      },
      clickItem(element) {
        this.selectedElement = element;
        this.internalurl = null;
        this.$refs.uploadComponent.clear();
        if (typeof (element.Url) != 'undefined' && element.Url != null && element.Url != "") {

          this.$refs.uploadComponent.showFile(element.Url, element.Text);
        }
        //alert(JSON.stringify(element))
        this.$refs.uploadComponent.open();

      },
      deleteChildren(elements) {
        for (var i = 0; i < elements.length; i++) {
          elements[i].IsDeleted = true;
          this.deleteChildren(elements[i].Elements);
        }
      },

      deleteItem(id, elements) {
        var isRoot = false;
        if (elements == null || typeof elements == "undefined") {
          elements = this.procedure.Elements;
          isRoot = true;
        }

        for (var i = 0; i < elements.length; i++) {
          if (elements[i].Id == id) {
            elements[i].IsDeleted = true;
            this.deleteChildren(elements[i].Elements);
          }
          else {
            this.deleteItem(id, elements[i].Elements);
          }
        }


        if (isRoot) {
          var proc = this.procedure;
          this.procedure = proc;
          Vue.set(proc, "Elements", elements);
          this.$forceUpdate();
          this.$store.markAsChanged();
        }

      },
      handleRefresh(val) {
        this.timeEst = parseFloat(this.procedure.EstimatedTimeTimeTicks) / 36000000000;
        this.$forceUpdate();
        this.setTimeControlValue();
      },

      setTimeControlValue() {
        this.minutes = 0;
        this.hours = parseInt(this.timeEst);
        var partOfHour = this.timeEst % 1;
        if (partOfHour > 0)
          this.minutes = parseInt((partOfHour * 60));
      },

      changeTimeEst(val) {
        this.procedure.EstimatedTimeTimeTicks = val * 36000000000;
        var hours = parseInt(val);
        var partOfHour = val % 1;
        var label = hours + "h";
        if (partOfHour > 0)
          label += ", " + (partOfHour * 60) + "min";
        this.$refs.timeEstimated.label = label;

      },
      updateTimeEst(val) {
        try {
          var url = '/api/Procedure/UpdateEstimatedTime?procedureId=' + this.procedure.Id + '&estimatedTime=' + val;
          this.$http.get(url).then(async response => {
            //alert('doSearch8')
            vm.$root.$emit('doSearch');
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      addingFromMenuClick(element) {
        var proc = this.procedure;
        var id = -1;
        for (var i = 0; i < element.Elements.length; i++) {
          element.Elements[i].Id = id--;
        }
        proc.Elements.push(element);
        this.procedure = proc;
        this.loadElements(proc.Elements);
      },
      quicklinkClick(element) {
        if (element.option == "qr") {
          //alert("show QR")
        }
        else if (element.option == "settings") {
          //alert("show settings")
        }
      },


    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
      this.$root.$on('procedure_add_element', this.addingFromMenuClick);

    },
    mounted() {
      // just for the demos, avoids form submit
      //jQuery.validator.setDefaults({
      //  debug: true,
      //  success: "valid"
      //});

      $("#setTimeForm").validate({
        rules: {
          hour: {
            required: true,
            number: true
          }
        }
      });

    },

    watch: {
    }
  };
</script>


<style scoped>


  /*
  .base-item {
    min-height: 100px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
    margin:auto;
    display:inline-block;
    overflow:visible;
    margin-top: 5px !important;
    width:initial !important;
    min-width:100%;
  }
  */

  .drag_container:before {
  }


  .drag_container {
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editmode.vue